/* eslint-disable react/prop-types */
import React from "react";
import { Box, Switch } from "@mui/material";
import { ErrorMessage, Field } from "formik";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

export default function SwitchField({ name, checked, type, label, ...rest }) {
  return (
    <SoftBox mb={1.5}>
      <SoftBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <SoftTypography component="label" variant="caption" fontWeight="bold">
          {label}
        </SoftTypography>
      </SoftBox>
      <br />
      <Field name={name} component={SwitchComp} {...rest} />
      <SoftBox mt={0.75}>
        <SoftTypography component="div" variant="caption" color="error">
          <ErrorMessage name={name} />
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

function SwitchComp(props) {
  const {
    form: { setFieldValue, ...formRest },
    field: { name, value, onChange },
    onToggle = () => {},
    defaultValue,
    ...rest
  } = props;

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={2}
      border="0.0625rem solid #d2d6da"
      padding="0.3rem 0.75rem"
      borderRadius="0.5rem"
      bgcolor="#fff"
    >
      <Switch
        size="medium"
        name={name}
        checked={typeof value === "boolean" ? value : defaultValue}
        onChange={(e) => {
          setFieldValue(name, e.target.checked);
          onToggle(e.target.checked);
        }}
        {...rest}
      />
      <SoftTypography variant="h5" style={{ color: "#495057", fontSize: "14px" }}>
        {(typeof value === "boolean" ? value : defaultValue) ? "Có" : "Không"}
      </SoftTypography>
    </Box>
  );
}
